/**
 * Login Component
 *
 * Simple login page that redirects to WorkOS AuthKit for authentication.
 * WorkOS handles all authentication methods (email/password, Google OAuth, etc.)
 */
import React from 'react';
import { useAuth } from '@shared/context';
import { Navigate, useLocation } from 'react-router-dom';
import Loader from '../loader/loader.component';
import { getDefaultRouteForRole, UserRole } from '../../routes/RoleRoute';

import './login.scss';

const Login = () => {
  const { signIn, isAuthenticated, isLoading, user } = useAuth();
  const location = useLocation();

  // Get the intended destination from state (set by RoleRoute redirect)
  const from = (location.state as { from?: string })?.from;

  // If already authenticated, redirect to intended destination or role-based default
  if (isAuthenticated) {
    // If there was an intended destination, go there
    if (from && from !== '/login') {
      console.log('[Login] Redirecting to intended destination:', from);
      return <Navigate to={from} replace />;
    }
    // Otherwise, use role-based default
    const primaryRole = (user?.roles?.[0] || 'CUSTOMER') as UserRole;
    const defaultRoute = getDefaultRouteForRole(primaryRole);
    console.log('[Login] No saved destination, redirecting by role:', { role: primaryRole, to: defaultRoute });
    return <Navigate to={defaultRoute} replace />;
  }

  return (
    <section className="login">
      <div className="container">
        <div
          className="row"
          style={{ display: 'flex', justifyContent: 'center' }}
        >
          <div className="col form">
            <form onSubmit={(e) => e.preventDefault()}>
              <div className="form-group title">
                <span className="fa fa-lock"></span>
                <label className="text-center call-txt">Log In</label>
              </div>

              <div className="form-group">
                <div className="col-md-12 pad">
                  <p style={{ textAlign: 'center', marginBottom: '24px', color: '#666' }}>
                    Sign in with your email or Google account
                  </p>
                </div>
              </div>

              <div className="form-group">
                <div className="col-md-12 pad">
                  {isLoading ? (
                    <Loader />
                  ) : (
                    <button
                      type="button"
                      className="btn btn-login"
                      onClick={() => signIn()}
                    >
                      Sign In
                    </button>
                  )}
                </div>
              </div>

              <div className="form-group">
                <div className="col-md-12 pad" style={{ marginTop: '16px' }}>
                  <a
                    href="/forgot-password"
                    className="forgot-link text-center"
                    style={{ display: 'block', textAlign: 'center' }}
                  >
                    Forgot Password?
                  </a>
                </div>
              </div>
            </form>

            <div className="row">
              <div className="col-md-12 text-center already">
                Don't have an account?
                <br />
                <a href="/join">
                  <span>Create one</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Login;
